import { FC, useMemo } from 'react';
import { ColumnInstance, Row, useTable } from 'react-table';
import { KTCardBody, KTIcon } from '../../../../../../_metronic/helpers';
import { SubscriptionDto, SubscriptionModalState } from '../../model/types';
import { useGetSubscriptions } from '../api/subscription.queries';
import { subscriptionsColumns } from './_columns';
import { SubscriptionCustomRow } from './SubscriptionCustomRow';

interface Props {
	openModal: SubscriptionModalState | null;
	setOpenModal: (open: SubscriptionModalState | null) => void;
}

export const SubscriptionTable: FC<Props> = ({ openModal, setOpenModal }) => {
	const { data: subscriptions, isLoading } = useGetSubscriptions();

	const data = useMemo(() => subscriptions || [], [subscriptions]);

	const columns = useMemo(
		() => [
			...subscriptionsColumns,
			{
				id: 'actions',
				Cell: ({ row }: { row: Row<SubscriptionDto> }) => (
					<div className='d-flex gap-4 justify-content-end'>
						<button
							className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
							onClick={() => setOpenModal({ type: 'edit', data: row.original })}
						>
							<KTIcon iconName='pencil' className='fs-3' />
						</button>
						<button
							className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
							onClick={() =>
								setOpenModal({ type: 'delete', data: row.original })
							}
						>
							<KTIcon iconName='trash' className='fs-3' />
						</button>
					</div>
				),
			},
		],
		[data]
	);

	const { getTableProps, getTableBodyProps, headers, rows, prepareRow } =
		useTable({
			columns,
			data,
		} as any);

	return (
		<KTCardBody className='py-4'>
			<div className='d-flex flex-stack'>
				<button
					type='button'
					className='btn btn-primary btn-sm'
					disabled={isLoading}
					onClick={() => {
						setOpenModal({ type: 'create', data: null });
					}}
				>
					{isLoading ? (
						<div
							className='spinner-border spinner-border-sm me-2'
							role='status'
						></div>
					) : (
						<KTIcon iconName='plus' className='fs-2 ps-1 me-2' />
					)}
					Добавить
				</button>
			</div>
			<div
				className='table-responsive w-100 pb-8'
				style={{ transform: 'scaleY(-1)' }}
			>
				<table
					style={{ transform: 'scaleY(-1)' }}
					id='kt_table_tags'
					className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
					{...getTableProps()}
				>
					<thead>
						<tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
							{headers?.map((column: ColumnInstance<any>) => (
								<th key={column.id} {...(column as any).getHeaderProps()}>
									{column.render('Header')}
								</th>
							))}
						</tr>
					</thead>
					<tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
						{rows?.length > 0 ? (
							rows.map((row: Row<any>, i) => {
								prepareRow(row);
								return (
									<SubscriptionCustomRow row={row} key={`row-${i}-${row.id}`} />
								);
							})
						) : (
							<tr>
								<td colSpan={7}>
									<div className='d-flex text-center w-100 align-content-center justify-content-center'>
										No matching records found
									</div>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			{/* {isLoading && <UsersListLoading />} */}
		</KTCardBody>
	);
};
